<template>
  <div>
    <v-chip class="ma-2" color="light-green lighten-3" label>
      <v-icon left> mdi-account-circle-outline </v-icon>
      <b>{{ tipo }}</b>
    </v-chip>
    <v-form ref="form" lazy-validation>
      <v-container>
        <v-row>
          <v-col cols="12" sm="4" md="4">
            <v-autocomplete
              :label="$t('cittadinanza')"
              v-model="riepilogo.ospite3.cittadinanza"
              :items="nazioni"
              item-text="DESCRIZIONE"
              item-value="DESCRIZIONE"
              required
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="4" md="4">
            <v-autocomplete
              :label="$t('luogonascita')"
              v-model="riepilogo.ospite3.luogonascita"
              :items="nazioni"
              item-text="DESCRIZIONE"
              item-value="DESCRIZIONE"
              required
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="4" md="4">
            <v-text-field
              v-mask="'##/##/####'"
              :label="$t('datanascita')"
              :hint="$t('formatodata')"
              v-model="riepilogo.ospite3.datanascita"
              required
              persistent-hint
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="5" md="5">
            <v-text-field
              :label="$t('nome')"
              v-model="riepilogo.ospite3.nome"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="5" md="5">
            <v-text-field
              :label="$t('cognome')"
              v-model="riepilogo.ospite3.cognome"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="2" md="2">
            <v-combobox
              v-model="riepilogo.ospite3.sesso"
              :items="sesso"
              :label="$t('sesso')"
            ></v-combobox>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
export default {
  name: "Anagrafica3",
  props: {
    tipo: String,
  },

  data: () => ({
    sesso: ["M", "F"],
  }),
  computed: {
    riepilogo: {
      get() {
        return this.$store.state.riepilogo;
      },
      set(value) {
        // this.$store.commit('updateMessage', value)
        alert(value);
      },
    },
    nazioni: {
      get() {
        return this.$store.state.nazioni;
      },
      set(value) {
        // this.$store.commit('updateMessage', value)
        alert(value);
      },
    },
  },
};
</script>
